import React from "react";
import { formatAmount } from "../../Utils/constants";

export default function tableCellRender(value, type) {
  switch (type) {
    case "single-val":
      return <div className="table-title-div">{value}</div>;
    case "date-val":
      return (
        <div className="table-title-div dates">
          <p>{value?.start_date}</p>
          <p>to</p>
          <p>{value?.end_date}</p>
        </div>
      );
    case "fund-dtls":
      return (
        <div className="table-title-div fund-dtls">
          <p className="title">{value?.title}</p>
          <p className="team">{value?.teams[0]?.title}</p>
        </div>
      );
    case "full-name":
      return (
        <div className="table-title-div">{`${value?.firstName} ${value?.lastName}`}</div>
      );
    case "array-item":
      return <div className="table-title-div">{value?.[0]?.title}</div>;
    case "amount":
      return <div className="table-title-div">{formatAmount(value)}</div>;
    case "array-of-participants":
      return (
        <div>
          {value.map((item, index) => (
            <div key={index} className="table-title-div">
              {item?.participant_first_name} {item?.participant_last_name} (
              {item?.participant_email})
            </div>
          ))}
        </div>
      );
    case "count":
      return <div className="table-title-div">{value?.length}</div>;
    default:
      return <div className="table-title-div">Cell not found</div>;
  }
}
